<!--违规申诉-->
<template>
  <div class="feedback">
      <div class="feedback-title">请选择申诉类型，完成申诉后将告知结果</div>
      <div class="feedback-content">
        <div
          class="feedback-content-item"
          v-for="(item, index) in feedbackLists"
          :key="index"
          @click="enterPage(item, index)"
        >
          <div class="feedback-content-item-title">{{ item.title }}</div>
          <div class="feedback-content-item-desc">{{ item.desc }}</div>
          <div class="feedback-content-item-arrow"></div>
        </div>
      </div>
    </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
const PAGE_TYPE = 'ZZUP_HELPCENTER_ACCOUNTAPPEAL'

export default {
  name: 'HelpCenterAccountAppeal',
  data() {
    return {
      feedbackLists: [
        {
          title: '封号申诉',
          desc: '账号涉嫌违规封禁，请点此进行申诉',
          jumpUrl: 'https://feentry.zhuanzhuan.com/spam_userAppeal?clientid=userRejectReason'
        },
        {
          title: '商品下架申诉',
          desc: '商品涉嫌违规下架，请点此进行申诉',
          jumpUrl: 'https://feentry.zhuanzhuan.com/SafeCenter?clientid=SafeCenterDetial&active=2'
        }
      ]
    }
  },
  components: {
    //
  },
  created() {
    native.setTitle({ title: '违规申诉' })
    lego.send({
      pagetype: PAGE_TYPE,
      actiontype: 'PAGE_SHOW'
    })
  },
  mounted() {
    //
  },
  methods: {
    enterPage(data, index) {
      lego.send({
        pagetype: PAGE_TYPE,
        actiontype: 'ENTER_CLICK',
        backup: {
          index,
          title: data.title
        }
      })
      native.skipToUrl({
        targetUrl: data.jumpUrl
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .feedback {
    position: absolute;
    width: 100%;
    height: 100%;
    background: white;
    padding: 0 32px;
    box-sizing: border-box;
    /*background: white;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*box-sizing: border-box;*/
    &-title {
      margin: 32px 0 0 0;
      font-family: PingFangSC-Regular;
      font-size: 28px;
      color: #999999;
    }
    &-content {
      &-item {
        margin: 24px 0 0 0;
        width: 686px;
        height: 154px;
        background: #f8f8f8;
        border-radius: 16px;
        border-radius: 16px;
        position: relative;
        &-title {
          position: absolute;
          top: 32px;
          left: 32px;
          font-family: PingFangSC-Medium;
          font-size: 32px;
          color: #111111;
        }
        &-desc {
          position: absolute;
          bottom: 32px;
          left: 32px;
          font-family: PingFangSC-Regular;
          font-size: 24px;
          color: #999999;
        }
        &-arrow {
          position: absolute;
          top: 64px;
          right: 32px;
          width: 26px;
          height: 26px;
          background: url('https://pic2.zhuanstatic.com/zhuanzh/n_v202a6169431c3443587f2fce427ac7d6a.png')
            no-repeat;
          background-size: contain;
          background-position: center;
        }
      }
    }
  }
</style>
